import React from 'react';

import {
  PageWrapper,
  OneHalfLayout,
  Flex,
  Placeholder,
  Panel
} from '@sopranodesign/pulse-components';
import { useMutation, useQueryClient } from '@sopranodesign/pulse-hooks';
import { PolicyAccept, BackButton } from '@sopranodesign/pulse-channels';

import { acceptPolicy as acceptPolicyApi } from '../api/settings';
import { useFacebookSettings } from '../hooks';
import FacebookLink from './FacebookLink';

const FacebookLanding = () => {
  const { settings, isLoading } = useFacebookSettings();

  const queryClient = useQueryClient();

  const { mutate: acceptPolicy } = useMutation({
    mutationFn: acceptPolicyApi,
    onSuccess: () => {
      queryClient.invalidateQueries('facebook/settings');
    }
  });

  const PolicyCheck = () => {
    if (!settings.has_given_data_consent) {
      return (
        <PolicyAccept
          handlePolicyAccept={acceptPolicy}
          policyUrl="https://developers.facebook.com/devpolicy/"
        />
      );
    }

    return <FacebookLink data-testid="facebook-settings" />;
  };

  return (
    <PageWrapper
      center
      half
      header="Facebook Messenger"
      prevAction={<BackButton to="/channels" />}>
      <Flex col center>
        <OneHalfLayout>
          {isLoading && (
            <Panel>
              <Placeholder items={1} subitems={3} />
            </Panel>
          )}
          {!isLoading && <PolicyCheck />}
        </OneHalfLayout>
      </Flex>
    </PageWrapper>
  );
};

export default FacebookLanding;
